import {Component, effect, inject} from '@angular/core';
import {AssetDetailsComponent} from "src/app/presentation/common/asset-details.component";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {NgClass} from "@angular/common";
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";
import {ToCapitalizedTextPipe} from "src/app/presentation/common/pipes/ToCapitalizedTextPipe";
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {ActionType, DataType} from "src/app/domain/domain-models";
import {
  allAnimalTypes,
  Animal,
  AnimalType,
  Paddock,
  SynchronizationStatus
} from "src/app/infrastructure/moovement-api/models/asset";
import {
  InternalNotificationsStore,
  InternalNotificationType
} from 'src/app/infrastructure/internal-notifications/internal-notifications.store';
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {AnimalSelectionStore} from 'src/app/domain/assets/animals/animal-selection.store';
import {unassignedAnimalsPaddock} from 'src/app/domain/assets/paddocks/unassigned-animals-paddock';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';

@Component({
  selector: 'app-animal-edit-form',
  imports: [
    GenericButtonComponent,
    SpinnerComponent,
    ToCapitalizedTextPipe,
    AnimalButtonComponent,
    NgClass
  ],
  templateUrl: './animal-edit-form.component.html',
  styleUrl: './animal-edit-form.component.css'
})
export class AnimalEditFormComponent extends AssetDetailsComponent<Animal> {

  paddocks: Paddock[] = []
  years: number[] = []
  animalTypes: AnimalType[] = allAnimalTypes
  animals: Animal[] = []
  selectedYear?: number
  selectedPaddock?: Paddock
  selectedAnimalType?: string

  private animalSelectionStore = inject(AnimalSelectionStore);
  private farmStore = inject(FarmStore);
  private internalNotificationStore = inject(InternalNotificationsStore);
  private paddockStore = inject(PaddockStore);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);

    effect(() => {
      const isOnline = this.networkStatusStore.isOnline();
      const selectedAnimals = this.animalSelectionStore.entities();
      this.animals = isOnline
        ? selectedAnimals
        : selectedAnimals.filter(animal => animal.synchronizationStatus == SynchronizationStatus.syncPending);
    });

    effect(() => {
      if (this.paddockStore.loading()) return;

      const paddocks = [...this.paddockStore.entities(), unassignedAnimalsPaddock];
      this.paddocks = paddocks;
      this.loading = false;
    });

    const today = new Date();
    for (let i = 0; i < 10; i++) {
      this.years.push(today.getFullYear() - i)
    }
  }

  setYob(year: number) {
    this.selectedYear = year;
    this.animals = this.animals.map(animal => {
      animal!.yearOfBirth = year.toString()
      return animal
    })
  }

  setAnimalType(animalType: AnimalType) {
    this.selectedAnimalType = animalType
    this.animals = this.animals.map(animal => {
      animal!.type = animalType
      return animal
    })
  }

  setPaddock(paddock: Paddock) {
    this.selectedPaddock = paddock
    const paddockId = paddock === unassignedAnimalsPaddock ? undefined : paddock.id;
    this.animals.forEach(animal => {
      animal.assignedPaddockId = paddockId;
    });
  }

  async applyChanges() {
    this.animals.forEach(async asset => {
      this.dataSynchronisationService.applyAction(
        DataType.animals,
        ActionType.mergeAsset,
        asset,
        SynchronizationStatus.syncPending
      );
    });
    this.internalNotificationStore.addNotification("Successfully edited animal(s)", InternalNotificationType.SUCCESS, false);
    this.router.navigate(['/main/information-center']);
  }
}
